import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setCompanyDetails, setStates } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
  isEUVatNumberCheckedAndCorrect: false,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchCompanyDetails = createAsyncThunk(
  "companyDetailsScreen/fetchCompanyDetails",
  async (country) => {
    return fetch(
      `${baseUrl}/api/registration-form-page/2/${country.countryCode}/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getCompanyDetails =
  (countryCode, language) => async (dispatch) => {
    const result = await dispatch(
      fetchCompanyDetails({ countryCode, language })
    );

    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setCompanyDetails(data?.page_content));
    if (data?.page_content?.states)
      dispatch(setStates(data?.page_content?.states?.value[0]));

    return data;
  };

export const verifyEuVatNumber = async (countryCode, euVat, language) => {
  const vatNumber = euVat.slice(2);
  return fetch(`${baseUrl}/api/check-vat-no/${countryCode}/${vatNumber}/`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Accept-Language": language === "en" ? "en-UK" : language,
    },
  }).then(async (res) => {
    const statusCode = res.status;
    if (res.ok) {
      if (statusCode !== 200) {
        return { isValid: true, responseStatus: statusCode };
      }
      const data = await res.json();

      return { isValid: data?.is_valid, responseStatus: statusCode };
    }
    return { isValid: false, responseStatus: statusCode };
  });
};

export const companyDetailsSlice = createSlice({
  name: "companyDetailsScreen",
  initialState,
  reducers: {
    changeIsEUVatNumberCheckedAndCorrect: (state, action) => {
      state.isEUVatNumberCheckedAndCorrect = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { changeIsEUVatNumberCheckedAndCorrect } =
  companyDetailsSlice.actions;

export default companyDetailsSlice.reducer;
